import { render, staticRenderFns } from "./Teleorientacion.vue?vue&type=template&id=35d25f64&scoped=true&"
import script from "./Teleorientacion.vue?vue&type=script&lang=js&"
export * from "./Teleorientacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d25f64",
  null
  
)

export default component.exports